export const Logo = () => {
  return (
    <svg
      width="152"
      height="20"
      viewBox="0 0 152 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="text-foreground"
    >
      <g clipPath="url(#clip0_12539_67969)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28 0V5H12V0H28ZM22.72 8L28 20H22.665L20 13L17.335 20H12L17.28 8H22.72Z"
          fill="#2E6BE6"
        />
      </g>
      <path
        d="M36.7215 10.0135C36.7215 6.289 39.0615 3.8515 42.084 3.8515C44.5995 3.8515 46.257 5.314 46.7445 7.537H45.2235C44.736 6.1525 43.7415 5.236 42.084 5.236C39.8025 5.236 38.262 7.1665 38.262 10.0135C38.262 12.841 39.783 14.791 42.084 14.791C43.7415 14.791 44.736 13.8745 45.2235 12.4705H46.7445C46.257 14.713 44.58 16.1755 42.084 16.1755C39.0615 16.1755 36.7215 13.738 36.7215 10.0135ZM47.6871 5.392V4.027H57.5736V5.392H53.4006V16H51.8601V5.392H47.6871ZM63.2555 10.93H61.13V16H59.5895V4.027H64.0355C66.434 4.027 67.955 5.236 67.955 7.498C67.955 9.487 66.785 10.618 64.913 10.8715L68.4425 16H66.6875L63.2555 10.93ZM61.13 5.3725V9.6235H63.9965C65.576 9.6235 66.434 8.824 66.434 7.498C66.434 6.172 65.576 5.3725 63.9965 5.3725H61.13ZM70.3488 16V4.027H71.8893V14.6155H77.9928V16H70.3488Z"
        fill="currentColor"
      />
      <path
        d="M83 4V16H92.4544V13.2853H86.158V11.2107H91.874V8.57422H86.158V6.69517H92.4544V4H83Z"
        fill="currentColor"
      />
      <path
        d="M103.878 4H101.014V10.1258L96.9552 4H94.4239V16H97.2879V9.46365L101.732 16H103.878V4Z"
        fill="currentColor"
      />
      <path
        d="M105.848 6.69517H109.017V16H112.114V6.69517H115.302V4H105.848V6.69517Z"
        fill="currentColor"
      />
      <path
        d="M117.47 4V16H126.924V13.2853H120.628V11.2107H126.344V8.57422H120.628V6.69517H126.924V4H117.47Z"
        fill="currentColor"
      />
      <path
        d="M132.653 12.0318L135.119 16H138.544L135.773 11.6998C137.217 11.153 138.239 9.90318 138.239 8.0843C138.239 5.46488 136.37 4 133.828 4H129.09V16H132.149V12.0318H132.653ZM132.149 6.63653H133.619C134.717 6.63653 135.218 7.20403 135.218 8.0843C135.218 8.96457 134.717 9.53207 133.619 9.53207H132.149V6.63653Z"
        fill="currentColor"
      />
      <defs>
        <clipPath id="clip0_12539_67969">
          <rect width="16" height="20" fill="white" transform="translate(12)" />
        </clipPath>
      </defs>
    </svg>
  );
};
